module.exports = __webpack_public_path__ + "static/media/filter-web.073223e2.png";